document.addEventListener('DOMContentLoaded', () => {
    const vIconToggle = document.getElementById('vIconToggle');
    const vDropdownMenu = document.getElementById('vDropdownMenu');

    if (vIconToggle && vDropdownMenu) {
        vIconToggle.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent default link behavior (e.g., jumping to top)
            vDropdownMenu.classList.toggle('show');
        });

        // Optional: Close dropdown when clicking outside
        document.addEventListener('click', (event) => {
            // Check if the click occurred outside the dropdown container
            const isClickInside = vIconToggle.contains(event.target) || vDropdownMenu.contains(event.target);
            if (!isClickInside && vDropdownMenu.classList.contains('show')) {
                vDropdownMenu.classList.remove('show');
            }
        });
    } else {
        console.warn("Dropdown elements (vIconToggle or vDropdownMenu) not found. Dropdown functionality may not work.");
    }
});